// Central react-query keys so views and mutations invalidate consistently.
export const qk = {
  workspaces: ['workspaces'] as const,
  workspace: (ws: string | null) => ['workspace', ws] as const,
  workspaceRoles: (ws: string | null) => ['workspace-roles', ws] as const,
  // simple-mode S3: Team page.
  members: (ws: string | null) => ['members', ws] as const,
  invites: (ws: string | null) => ['invites', ws] as const,
  apiKeys: (ws: string | null) => ['api-keys', ws] as const,
  marketplace: (ws: string | null) => ['marketplace', ws] as const,
  connections: (ws: string | null) => ['connections', ws] as const,
  connectedAccounts: (ws: string | null) => ['connected-accounts', ws] as const,
  activity: (ws: string | null, since: string) => ['activity', ws, since] as const,
  activityProbe: (ws: string | null) => ['activity-probe', ws] as const,
  triggers: (ws: string | null) => ['triggers', ws] as const,
  // rbac-restore R2 (developer mode): webhooks, server secrets.
  webhooks: (ws: string | null) => ['webhooks', ws] as const,
  serverSecrets: (ws: string | null, serverId: string) => ['server-secrets', ws, serverId] as const,
  toolSearch: (ws: string | null, q: string, category: string) => ['tool-search', ws, q, category] as const,
  toolSchema: (ws: string | null, name: string) => ['tool-schema', ws, name] as const,
  toolSessions: (ws: string | null) => ['tool-sessions', ws] as const,
  // Per-workspace plan entitlements (GET /entitlements); re-read on workspace switch.
  entitlements: (ws: string | null) => ['entitlements', ws] as const,
  // rbac-restore R3 (developer mode): toolkit rules, auth configs, end users, skills.
  connectorPolicies: (ws: string | null) => ['connector-policies', ws] as const,
  authConfigs: (ws: string | null) => ['auth-configs', ws] as const,
  endUsers: (ws: string | null, prefix: string) => ['end-users', ws, prefix] as const,
  skills: (ws: string | null) => ['skills', ws] as const,
  // Account-scoped (the caller's email), not workspace-scoped.
  myPreferences: ['me-preferences'] as const,
  myInvites: ['me-invites'] as const,
  invitePeek: (token: string) => ['invite-peek', token] as const,
  // Public, workspace-independent.
  toolCategories: ['tool-categories'] as const,
  mcpDirectory: ['mcp-directory'] as const,
}
